export default __webpack_public_path__ + "static/media/vue.47bdfb5a.svg";